import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

export default function MultiSelect({ data, onChange, currentValue }) {
  const wrapperRef = useRef();
  const selectId = useRef(`select-${Math.random().toString(36).substr(2, 9)}`);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [show, setShow] = useState(false);

  function open() {
    setShow(true);
  }

  function close() {
    setShow(false);
  }

  const select = (index) => (e) => {
    const tmpOptions = options.slice(0);
    const tmpSelected = selected.slice(0);
    if (!tmpOptions[index].selected) {
      tmpOptions[index].selected = true;
      tmpOptions[index].element = e.target;
      setSelected([...selected, index]);
      setOptions(tmpOptions);
    } else {
      tmpSelected.splice(tmpSelected.lastIndexOf(index), 1);
      tmpOptions[index].selected = false;

      setOptions(tmpOptions);
      setSelected(tmpSelected);
    }

    const tmpValue = [];
    tmpOptions.forEach((x) => {
      if (x.selected) {
        const item = {
          label: x.text,
          value: x.value
        };

        tmpValue.push(item);
      }
    });

    onChange(tmpValue);
  };

  const remove = (index, option) => () => {
    const tmpOption = options.slice(0);
    const tmpSelected = selected.slice(0);

    tmpOption[option].selected = false;
    tmpSelected.splice(index, 1);

    setOptions(tmpOption);
    setSelected(tmpSelected);

    const tmpValue = [];
    tmpOption.forEach((x) => {
      if (x.selected) {
        const item = {
          label: x.text,
          value: x.value
        };

        tmpValue.push(item);
      }
    });

    onChange(tmpValue);
  };

  function loadOptions() {
    const tmpOptions = [];
    const option = document.getElementById(selectId.current)?.options || [];

    for (let i = 0; i < option.length; i++)
      tmpOptions.push({
        value: option[i].value,
        text: option[i].innerText,
        selected:
          option[i].getAttribute('selected') != null
            ? option[i].getAttribute('selected')
            : false
      });

    let tmpOpt = tmpOptions.slice(0);
    if (currentValue) {
      currentValue.forEach((x) => {
        tmpOpt = tmpOpt.map((v) => {
          if (v.value === x.value) {
            const item = {
              ...v,
              selected: x.selected
            };
            return item;
          }

          return v;
        });
      });
      const tmpSelected = tmpOpt.map((v, i) => {
        if (v.selected) {
          return i;
        }

        return undefined;
      });

      if (tmpSelected.length > 0) {
        setSelected(
          tmpSelected.filter((e) => {
            return typeof e !== 'undefined';
          })
        );
      }
    }

    setOptions(tmpOpt);
  }

  function handleClickOutside(e) {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(e.target)
    ) {
      // if (show) close();
      close();
    }
  }

  useEffect(() => {
    loadOptions();

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <select className="hidden" id={selectId.current}>
        {data &&
          data.map((x) => {
            if (x.selected) {
              return (
                <option key={x.value} value={x.value} selected>
                  {x.label}
                </option>
              );
            }

            return (
              <option key={x.value} value={x.value}>
                {x.label}
              </option>
            );
          })}
      </select>

      <div className="w-full">
        <form>
          <input
            name="values"
            type="hidden"
            value={selected.map((x) => options[x]?.value ?? '')}
          />

          <div className="inline-block relative w-full" ref={wrapperRef}>
            <div className="flex flex-col items-center relative">
              <div onClick={open} className="w-full  svelte-1l8159u">
                <div className="my-2 p-1 flex border border-gray-200 bg-white rounded svelte-1l8159u">
                  <div className="flex flex-auto flex-wrap">
                    {selected.map((x, index) => (
                      <div
                        key={options[x]?.value}
                        className="flex justify-center items-center m-1 font-medium py-1 px-2 bg-white rounded-full text-teal-700 bg-teal-100 border border-teal-300 "
                      >
                        <div className="text-xs font-normal leading-none max-w-full flex-initial">
                          {options[x]?.text}
                        </div>
                        <div className="flex flex-auto flex-row-reverse">
                          <div onClick={remove(index, x)}>
                            <svg
                              className="fill-current h-6 w-6 "
                              role="button"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M14.348,14.849c-0.469,0.469-1.229,0.469-1.697,0L10,11.819l-2.651,3.029c-0.469,0.469-1.229,0.469-1.697,0
                                c-0.469-0.469-0.469-1.229,0-1.697l2.758-3.15L5.651,6.849c-0.469-0.469-0.469-1.228,0-1.697s1.228-0.469,1.697,0L10,8.183
                                l2.651-3.031c0.469-0.469,1.228-0.469,1.697,0s0.469,1.229,0,1.697l-2.758,3.152l2.758,3.15
                                C14.817,13.62,14.817,14.38,14.348,14.849z"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}

                    {selected.length == 0 ? (
                      <div className="flex-1">
                        <input
                          readOnly={true}
                          placeholder="Select a option"
                          className="bg-transparent p-1 px-2 appearance-none outline-none h-full w-full text-gray-800"
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200 svelte-1l8159u">
                    {show ? (
                      <button
                        type="button"
                        onClick={open}
                        className="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none"
                      >
                        <svg
                          version="1.1"
                          className="fill-current h-4 w-4"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M17.418,6.109c0.272-0.268,0.709-0.268,0.979,0s0.271,0.701,0,0.969l-7.908,7.83
  c-0.27,0.268-0.707,0.268-0.979,0l-7.908-7.83c-0.27-0.268-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.979,0L10,13.25
  L17.418,6.109z"
                          />
                        </svg>
                      </button>
                    ) : null}
                    {!show ? (
                      <button
                        type="button"
                        onClick={close}
                        className="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none"
                      >
                        <svg
                          className="fill-current h-4 w-4"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M2.582,13.891c-0.272,0.268-0.709,0.268-0.979,0s-0.271-0.701,0-0.969l7.908-7.83
  c0.27-0.268,0.707-0.268,0.979,0l7.908,7.83c0.27,0.268,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.978,0L10,6.75L2.582,13.891z
  "
                          />
                        </svg>
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="w-full px-4">
                {show ? (
                  <div className="absolute shadow top-100 bg-white z-40 w-full left-0 rounded max-h-select overflow-y-auto svelte-5uyqqj">
                    <div className="flex flex-col w-full">
                      {options.map((x, index) => (
                        <div key={x.value}>
                          <div
                            className="cursor-pointer w-full border-gray-100 rounded-t border-b hover:bg-teal-100"
                            onClick={select(index)}
                          >
                            <div
                              className={`flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative ${
                                x.selected ? 'border-purple-900' : ''
                              }`}
                            >
                              <div className="w-full items-center flex">
                                <div className="mx-2 leading-6">{x.text}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

MultiSelect.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  currentValue: PropTypes.array
};
